import Ten99Api from 'Agent/1099s/api/Ten99Api';
import {Ten99} from 'Agent/1099s/models/1099';
import {AsyncResult, fromResult, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {changeTen99s, getTen99s, Ten99ActionType} from '../ducks/1099';

export function* getTen99sFromApi(action: ReturnType<typeof getTen99s>) {
  if (action.payload.page) {
    yield put(changeTen99s(new LoadingAdditional(action.payload.page)));
  } else {
    yield put(changeTen99s(new Loading(action.payload.page)));
  }

  const result: AsyncResult<Page<Ten99>> = yield action.payload.page
    ? call(mergeWithNextPage, {existingPage: action.payload.page})
    : call(Ten99Api.getTen99s, action.payload.encryptedIdentifier, action.payload.isNewYork, action.payload.filter);

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeTen99s(value)),
      value => put(changeTen99s(value))
    )
  );
}

export function* fetch1099sSaga() {
  yield takeLatest(Ten99ActionType.GET_TEN99s, getTen99sFromApi);
}

export default function*() {
  yield all([fetch1099sSaga()]);
}
